<div class="flex items-end" [ngClass]="{'place-content-end': messageSide === 'RIGHT'}">
  <!-- Message Icon -->
  <div [ngClass]="messageSide === 'LEFT' ? 'order-1' : 'order-2'">
    @if (showIconBg) {
      <div class="flex flex-row rounded-[2rem] shrink-0 w-[2.5rem] h-[2.5rem] justify-center items-center" [ngClass]="iconBgClasses">
        <ng-container *ngTemplateOutlet="messageIcon"/>
      </div>
    } @else {
      <ng-container *ngTemplateOutlet="messageIcon"/>
    }
  </div>

  <!-- Message Body -->
  <div [ngClass]="messageSide === 'LEFT' ? 'order-2' : 'order-1'">
    <div class="px-6 py-3 rounded-t-[2rem] whitespace-pre-wrap" [ngClass]="calculatedBodyClasses">{{ messageBody }}</div>
    <!-- Message Date -->
    <div class="text-body-small flex" [ngClass]="calculatedDateClasses">
      {{ messageDate | format: 'TIME_ONLY' }}
    </div>
  </div>
</div>

<ng-template #messageIcon>
  @if (useTextForIcon) {
    <p class="text-title-medium" [ngClass]="iconClasses">{{ messageIconText }}</p>
  } @else {
    <mat-icon class="mat-icon-size-6" [ngClass]="iconClasses">{{ messageIconName }}</mat-icon>
  }
</ng-template>
